export function formatActivityError(err, salespersonName) {
  if (!err) return "";
  const str = String(err);
  const lower = str.toLowerCase();

  // 1. Connection / Timeout errors
  if (lower.includes("read timed out") || lower.includes("timed out") || lower.includes("timeout")) {
    return "WhatsApp service timed out. Please retry sending.";
  }
  if (
    lower.includes("connection refused") ||
    lower.includes("max retries exceeded") ||
    lower.includes("failed to establish a new connection") ||
    lower.includes("httpconnectionpool") ||
    lower.includes("httpsconnectionpool")
  ) {
    return "WhatsApp service is temporarily unreachable. Please ensure WhatsApp server is active.";
  }

  // 2. WhatsApp connection / session / detached frame errors
  if (lower.includes("not connected for user") || lower.includes("please scan the qr") || lower.includes("whatsapp is not connected")) {
    return salespersonName
      ? `WhatsApp is not connected for ${salespersonName}. Please scan the QR code in settings to connect.`
      : "WhatsApp is not connected. Please scan the QR code in WhatsApp settings to connect.";
  }
  if (lower.includes("getchat") || lower.includes("wwebjs")) {
    return "WhatsApp session is still syncing. Please wait a few seconds and retry.";
  }
  if (
    lower.includes("detached frame") ||
    lower.includes("execution context was destroyed") ||
    lower.includes("target closed") ||
    lower.includes("session closed") ||
    lower.includes("protocol error") ||
    lower.includes("disconnected unexpectedly")
  ) {
    return "WhatsApp session disconnected unexpectedly. Please reconnect WhatsApp in settings.";
  }

  // 3. Destination phone / registration
  if (lower.includes("not registered on whatsapp")) {
    return "This phone number is not registered on WhatsApp.";
  }
  if (lower.includes("missing destination phone") || lower.includes("invalid phone")) {
    return "Recipient phone number is invalid or missing.";
  }

  // 4. Salesperson assignment
  if (lower.includes("no assigned salesperson")) {
    return "No salesperson is assigned to handle messaging for this record.";
  }

  // 5. Media attachments
  if (lower.includes("media file could not be found") || (lower.includes("media") && (lower.includes("fetch") || lower.includes("download")))) {
    return "Could not load or attach the media file. Please check attachment settings.";
  }

  // 6. Gmail / Email errors
  if (lower.includes("gmail not connected") || lower.includes("invalid_grant") || lower.includes("token expired")) {
    return "Gmail account is not connected or token has expired. Please reconnect in settings.";
  }
  if (lower.includes("missing destination email") || lower.includes("invalid email")) {
    return "Recipient email address is invalid or missing.";
  }
  if (lower.includes("zeptomail") || lower.includes("smtp") || lower.includes("authentication failed")) {
    return "Email delivery failed. Please verify email address and sender configurations.";
  }

  // Clean any residual technical UUIDs like (7de2db27-2b7d-404b-91d9-b0fbd63ec045)
  const cleaned = str.replace(/\([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\)/gi, "").trim();
  return cleaned || str;
}
